import { eTipoPermissao } from '@/enums/ePermissoes';
export default [
    {
        description: 'Área do Conhecimento',
        path: '/biblioteca/bibareaconhecimento',
        name: 'bibareaconhecimento',
        component: () => import('@/views/biblioteca/bibareaconhecimento/Index.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_AREADECONHECIMENTONOVO_MENU_1300801899],
        },
        goesToMenu: true,
    },
    {
        description: 'Cadastro de Áreas do Conhecimento',
        path: '/biblioteca/bibareaconhecimento/cadastro/:id?',
        parent: 'bibareaconhecimento',
        name: 'bibareaconhecimento_create',
        component: () => import('@/views/biblioteca/bibareaconhecimento/InclusaoEdicao.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_AREADECONHECIMENTONOVO_MENU_1300801899],
        },
        goesToMenu: true,
    },
]
